<template>
	<div>
		
		<div class="page-header-controls-search">			
			<input type="text" v-model="search" @input="doSearch" :placeholder="$t('label.search')">
		</div>
		
		<div class="select">
			<select v-model="category" @change="doSearch">
				<option :value="null">{{ this.$t('label.allCustomers') }}</option>
				<option v-for="item in categories" :value="item.id">{{ item.name }}</option>
			</select>
		</div>

	</div>
</template>

<script>
  import _ from 'lodash'

  export default {
    data () {
      return {
        search: null,
        category: null,
        categories: []
      }
    },
    mounted () {
      this.loadCategories()
    },
    methods: {
      doSearch: _.debounce(function (e) {
        this.$events.fire('customer-search', {
          search: this.search,
          category: this.category
        })
      }, 500),
      loadCategories () {
        this.$api.get('/v1/categories').then(response => {
          this.categories = response.data.data
        }).catch(error => {
          console.error(error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/SearchBar.vue